import React, { FunctionComponent, useCallback } from 'react';
import { Link } from '@doveit/lego';
import * as styles from './SeoLinks.style';
import { URLObject } from '../../utils/links';

export interface SeoLink {
  title: string,
  to: URLObject,
}

export interface SeoLinksProps {
  links: SeoLink[],
  onLinkClick?: (to: URLObject) => void,
}

const SeoLinks: FunctionComponent<SeoLinksProps> = ({
  links,
  onLinkClick,
}) => {
  const internalOnLinkClick = useCallback(
    (to) => () => {
      onLinkClick(to);
    },
    [onLinkClick],
  );
  return (
    <ul>
      {
        links.map((link) => (
          <li key={link.title}>
            <Link
              href={link.to.as}
              onClick={onLinkClick && internalOnLinkClick(link.to)}
              css={styles.link}
              data-ref="seo-links-anchor"
            >
              {link.title}
            </Link>
          </li>
        ))
      }
    </ul>
  );
};

export default SeoLinks;
